<template>
  <span
    class="field__notice"
    tabindex="0"
    role="img"
    :aria-label="text"
    @mouseenter="show"
    @mouseleave="hide"
    @focus="show"
    @blur="hide"
  >
    <svg viewBox="0 0 24 24" focusable="false" aria-hidden="true">
      <circle cx="12" cy="12" r="10" fill="#999999" />
      <path fill="#ffffff" d="M11 6.5h2v7.5h-2zM11 15.5h2v2h-2z" />
    </svg>

    <!-- position: fixed 이므로 부모의 overflow 에 잘리지 않는다 -->
    <span
      v-if="visible"
      class="field__tooltip"
      :style="{ top: top + 'px', left: left + 'px' }"
    >{{ text }}</span>
  </span>
</template>

<script>
const TOOLTIP_MAX_WIDTH = 260;
const VIEWPORT_MARGIN = 8;

export default {
  name: "FieldNotice",

  props: {
    text: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      visible: false,
      top: 0,
      left: 0,
    };
  },

  methods: {
    show() {
      const rect = this.$el.getBoundingClientRect();
      const half = TOOLTIP_MAX_WIDTH / 2;
      const min = half + VIEWPORT_MARGIN;
      const max = window.innerWidth - half - VIEWPORT_MARGIN;
      const center = rect.left + rect.width / 2;

      this.top = rect.bottom + 8;
      this.left =
        max < min ? window.innerWidth / 2 : Math.min(Math.max(center, min), max);
      this.visible = true;
    },

    hide() {
      this.visible = false;
    },
  },
};
</script>

<style scoped lang="scss">
.field__notice {
  flex: none;
  display: inline-flex;
  align-items: center;
  margin-left: 5px;
  overflow: visible;
  cursor: help;
  outline: none;

  svg {
    width: 13px;
    height: 13px;
    display: block;
  }
}

.field__tooltip {
  position: fixed;
  z-index: 100;
  max-width: 260px;
  padding: 8px 10px;
  transform: translateX(-50%);
  font-size: 12px;
  font-weight: normal;
  line-height: 1.5;
  text-align: left;
  color: #ffffff;
  background-color: #333333;
  border-radius: 4px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
  overflow: visible;
  text-overflow: clip;
  white-space: normal;
  pointer-events: none;
}
</style>



// WEBPACK FOOTER //
// src/components/contents/shared/FieldNotice.vue